import ActionPanel from '../action-panel/ActionPanel';
import Timecard from '../timecard/TimeCard';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dateUtil from '../../util/dateUtil';
import { isAndroid } from '../../util/helperFunctions';
import { createTimecard, getTimecard } from '../../redux/timecard';
import TimecardDatasheet from '../timecard/TimecardDatasheet';
import TimecardReview from './TimecardReview';
import Welcome from './Welcome';
import {
  PlayCircleFilledWhite,
  Visibility,
  WatchLater,
  AttachFile,
  CameraAltOutlined,
  ViewDay
} from '@material-ui/icons';
import { Grid, Typography, Chip, Button, makeStyles, AppBar } from '@material-ui/core';
import { openCaptureReceipt, openUploadReceipt } from '../../redux/receipt';

//multi-use styles
const useStyles = makeStyles((theme) => ({
  header: {
    height: 38,
    marginBottom: 4,
    backgroundColor: theme.palette.background.primary,
    color: theme.palette['primary'].contrastText,
  },
  footer: {
    height: 40,
    backgroundColor: theme.palette.background.primary,
    color: theme.palette['primary'].contrastText,
  },
  pane: { marginBottom: 100 },
}));

const MobileUx = () => {
  const classes = useStyles();
  const timecard = useSelector((state) => state.timecard);
  const timecards = useSelector((state) => state.user.timecards);
  const draft = useSelector((state) => state.draft);
  const [view, setView] = useState('playing');
  const dispatch = useDispatch();

  useEffect(() => {
    if (draft) setView('playing');
  }, [draft]);

  const selectTimecard = (timecardId) => {
    if (timecardId == timecard.timecardId) {
      //just switch to now playing view
      setView('playing');
    } else if (timecardId > 0) {
      // load the selected timecard
      dispatch(getTimecard(timecardId));
    } else {
      dispatch(createTimecard()); // create a new timecard and load it
      setView('playing');
    }
  };

  //automatically change the view if the time card id or status changes
  useEffect(() => {
    switch (timecard.status) {
      case 'DRAFT':
        setView('playing');
        break;
      case 'SUBMITTED':
        setView('entries');
        break;
      case null:
      case undefined:
        setView('welcome');
        break;
      default:
        setView('review');
        break;
    }
  }, [timecard.timecardId, timecard.status]);

  const FooterItem = ({ itemView, icon }) => {
    return (
      <Grid
        item
        onClick={() => {
          setView(itemView);
          if (itemView == 'camera') {
            dispatch(openCaptureReceipt());
          } else if (itemView == 'receipt') {
            dispatch(openUploadReceipt());
          }
        }}
        style={
          view == itemView
            ? {
              width: isAndroid() ? '16.6%' : '20%',
              height: 40,
              paddingTop: 8,
              cursor: 'pointer',
              backgroundColor: '#072655',
            }
            : { width: isAndroid() ? '16.6%' : '20%', height: 40, paddingTop: 8, cursor: 'pointer' }
        }
      >
        {icon}
      </Grid>
    );
  };

  const Header = () => {
    return (
      <Grid item xs={12} style={{ height: 44 }}>
        <AppBar position="fixed">
          <Grid container style={{ padding: 8 }}>
            <Grid item xs={4}>
              <Typography>POST 2.0</Typography>
            </Grid>
            <Grid item xs={8} style={{ textAlign: 'right' }}>
              <Typography
                onClick={() => setView('selector')}
                style={{ cursor: 'pointer' }}
              >
                Period ending: {dateUtil.stringToShortDateFormat(timecard.endDate)}
              </Typography>
            </Grid>
          </Grid>
        </AppBar>
      </Grid>
    );
  };

  return (
    <Grid container id="post2-root-mobile">
      <Header />

      {/* welcome pane */}
      {view == 'welcome' && (
        <Grid
          item
          xs={12}
          className={classes.pane}
          style={{ padding: 10, textAlign: 'center' }}
        >
          <Welcome />
        </Grid>
      )}

      {/* timecard selector pane */}
      {view == 'selector' && timecards?.length && (
        <Grid
          container
          className={classes.pane}
          style={{ padding: 10, textAlign: 'center' }}
        >
          <Grid item xs={12}>
            <Button onClick={() => selectTimecard(-1)}>Create Next Timecard</Button>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Or select timecard to view...</Typography>
          </Grid>
          {timecards.map((item) => {
            return (
              <Grid item xs={12} key={item.timecardId}>
                <Button onClick={() => selectTimecard(item.timecardId)}>
                  <Typography variant="h7">
                    {dateUtil.stringToShortDateFormat(item.startDate)} -
                    {dateUtil.stringToShortDateFormat(item.endDate)} (Card #
                    {item.timecardId}) <Chip label={item.status} />
                  </Typography>
                </Button>
              </Grid>
            );
          })}
          <Grid item xs={12} style={{ marginTop: 20 }}>
            <Button onClick={() => setView('playing')}>Cancel</Button>
          </Grid>
        </Grid>
      )}

      {/* review/submission pane */}
      {view == 'review' && (
        <Grid item xs={12} className={classes.pane}>
          <TimecardReview timecard={timecard} />
        </Grid>
      )}

      {/* timesheet pane */}
      {view == 'timesheet' && (
        <Grid item xs={12} className={classes.pane}>
          <TimecardDatasheet
            timecard={timecard}
            disabled={timecard.status != 'DRAFT'}
            key={timecard.timecardId}
          />
        </Grid>
      )}

      {/* entries pane */}
      {(view == 'entries' || view == 'camera' || view == 'receipt') && (
        <Grid item xs={12} className={classes.pane}>
          <Timecard />
        </Grid>
      )}

      {/* now playing pane */}
      {view == 'playing' && (
        <Grid item xs={12} className={classes.pane}>
          <ActionPanel />
        </Grid>
      )}

      {/* footer */}
      <AppBar
        position="fixed"
        color="primary"
        style={{ top: 'auto', bottom: 0, height: 40 }}
      >
        <Grid container style={{ textAlign: 'center' }}>
          <Grid container style={{ textAlign: 'center' }}>
            <FooterItem itemView="playing" icon={<PlayCircleFilledWhite />} />
            <FooterItem itemView="entries" icon={<ViewDay />} />
            {isAndroid() && <FooterItem itemView="camera" icon={<CameraAltOutlined />} />}
            <FooterItem itemView="receipt" icon={<AttachFile />} />
            <FooterItem itemView="timesheet" icon={<WatchLater />} />
            <FooterItem itemView="review" icon={<Visibility />} />
          </Grid>
        </Grid>
      </AppBar>
    </Grid>
  );
};

export default MobileUx;
